module.exports = __webpack_public_path__ + "static/media/bannerDesktop.a9135c3c.jpg";